import React from "react";

interface FABProps {
  className?: string;
  setExpandedState?: boolean;
  content?: string;
}

interface FABState {
  isExpanded: boolean;
}

export default class FAB extends React.Component<FABProps, FABState> {
  constructor(props: FABProps) {
    super(props);

    this.state = {
      isExpanded: props.setExpandedState ? props.setExpandedState : false,
    };

    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  toggleVisibility(): void {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  componentWillReceiveProps(props: FABProps): void {
    const { setExpandedState } = props;

    if (setExpandedState !== this.state.isExpanded) {
      this.setState({ isExpanded: setExpandedState });
    }
  }

  componentWillMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e): boolean {
    if (this.state.isExpanded && e.keyCode === 27) {
      this.toggleVisibility();
    }

    return true;
  }

  render() {
    const { isExpanded } = this.state;
    const { className, content } = this.props;

    return (
      <div
        className={`fab ${isExpanded ? "fab--expanded" : ""} ${
          className ? className : ""
        }`}
      >
        <div className="fab__button" onClick={this.toggleVisibility}></div>
        <div className="fab__overlay" onClick={this.toggleVisibility}></div>
        <div className="fab__content">
          <div
            className="fab__inner"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </div>
      </div>
    );
  }
}
